import { Route, Routes } from "react-router-dom";

import PriceRemarkLabelAudit from "./list";

export default function PriceRemarkLabelAuditRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PriceRemarkLabelAudit />} />
    </Routes>
  );
}
